import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getHotelRateCodesSuccess, getHotelRateCodesRequest } from '../../slices/user';

function* getHotelRateCodesWorker() {
  try {
    const { hotelRateCodes, loaded } = yield select((store) => store.user);

    if (loaded && !hotelRateCodes) {
      const url = 'users/agencyHotelRateCodes';
      const config = {
        method: 'GET',
        url,
      };
      const { data } = yield call(axios, config);
      yield put(getHotelRateCodesSuccess(data));
    }
  } catch (error) {
    yield put(getHotelRateCodesSuccess());
    console.error(error);
  }
}

function* getHotelRateCodesWatcher() {
  yield takeLatest(getHotelRateCodesRequest.toString(), getHotelRateCodesWorker);
}

export default getHotelRateCodesWatcher;
